import axiosInstance from '../api/axiosConfig';
import { getApiBaseUrl } from '../baseUrl';

export * from './dashboard/index';
export * from './gestaoPrefeitura';

// Função para buscar prefeitura por ID
export const buscarPrefeituraPorId = async (id: string) => {
  const apiUrl = getApiBaseUrl();
  try {
    const response = await axiosInstance.get(`${apiUrl}/prefeituras/${id}`);
    return response.data;
  } catch (error: any) {
    console.error('Erro ao buscar prefeitura:', error);
    throw error;
  }
};

// Função para atualizar dados da prefeitura
export const atualizarPrefeitura = async (id: number, dados: any) => {
  const apiUrl = getApiBaseUrl();
  try {
    const response = await axiosInstance.put(`${apiUrl}/prefeituras/${id}`, dados);
    return response.data;
  } catch (error: any) {
    console.error('Erro ao atualizar prefeitura:', error);
    throw error;
  }
};